var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[(_vm.modulos !== null)?_c('Banner'):_vm._e()],1),(!_vm.isLoading)?_c('Modulos',{attrs:{"modulos":_vm.modulos}}):_c('v-row',[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"black","dark":""}},[_vm._v(" Modulos ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }